<script setup lang="ts">
import {reactive} from "vue";
import {forgotPassword} from "@/Services/auth";
import {Button, InputText, Label} from "@/Components/Library";
import {useMainStore} from "@/Stores/store";
import {Messages} from "@/Components/Forms";

const $store = useMainStore();
const bag = "forgot-password";

defineProps<{
    status?: string;
}>();

const state = reactive({
    loading: false,
});

const forgotPasswordForm = reactive({
    email: null,
});

const submit = async () => {
    try {
        state.loading = true;
        const data = await forgotPassword(forgotPasswordForm);
        $store.addMessage({
            text: data.status,
            type: "success",
            bag: bag,
        });
    } catch (e) {
        console.log(e);
    } finally {
        state.loading = false;
    }
};
</script>
<template>
    <div>
        <h1 class="mb-4 border-b-2 border-white pb-1 text-xl font-bold">Forgot password</h1>
        <div>
            <div class="mb-4 text-sm leading-relaxed">
                Forgot your password? No problem. Just let us know your email address and we will email you a password
                reset link that will allow you to choose a new one.
            </div>
            <div v-if="status" class="mb-4 text-sm font-medium text-green-600 dark:text-green-400">
                {{ status }}
            </div>
            <form @submit.prevent="submit" class="flex flex-col gap-4">
                <div class="flex flex-col">
                    <Label class="mb-1" for="email" required>Email address</Label>
                    <InputText
                        class="bg-transparent text-white"
                        placeholder="Registered email address"
                        id="email"
                        type="email"
                        v-model="forgotPasswordForm.email"
                        required
                        autofocus
                        fluid
                        autocomplete="username"
                    />
                </div>
                <Messages :bag="bag" />
                <div class="mb-16 flex flex-col items-center gap-3">
                    <Button
                        type="submit"
                        class="bg-askr-green text-white hover:brightness-110"
                        :disabled="state.loading"
                        :loading="state.loading"
                    >
                        Email Password Reset Link
                    </Button>
                    <RouterLink to="/login">Log in</RouterLink>
                </div>
            </form>
        </div>
    </div>
</template>
